<template>
  <div>
    <div class="text-center">
      <h4>{{label}}</h4>
    </div>

    <v-row>
      <v-col cols=12 sm=6>
        <div class="d-flex justify-space-between">
          <div>{{$t('menus.resourceLimits.limit')}}</div>
          <div>{{ getFormattedValue(limitObject.limit) }}</div>
        </div>
        <div class="d-flex justify-space-between">
          <div>{{$t('menus.resourceLimits.usage')}}</div>
          <div>{{ getFormattedValue(limitObject.usage) }}</div>
        </div>
        <div class="mt-1 pb-2">
          <v-progress-linear
            v-bind:model-value="limitObject.percentage"
            height="16"
          >
            <small>{{ limitObject.percentage }}%</small>
          </v-progress-linear>
        </div>
      </v-col>


      <v-col v-if="!disableTeamUsers" cols=12 sm=6 >
        <div v-if="isAddonValid" class="d-flex justify-space-around mt-2">
          <v-text-field
            type="text"
            v-bind:model-value="value"
            v-bind:label="$t('menus.resourceLimits.quantity')"
            append-icon="mdi-plus-circle-outline"
            v-on:click:append="increment()"
            prepend-icon="mdi-minus-circle-outline"
            v-on:click:prepend="decrement()"
            hide-details
            readonly
            variant="solo" flat
            density="compact"
          ></v-text-field>
        </div>
        <div v-else class="bg-info mt-2">
          {{$t('menus.resourceLimits.addonUnavailable')}}
        </div>

        <v-sheet v-if="addonObject" elevation="0" color="secondary" rounded class="mt-2 px-2 text-center">
          <div>
            <span v-if="value > 0">{{value}} x </span>{{addonObject.product.name}}
          </div>
          <div v-show="value > 0">
            € {{ ((addonObject.price.price * value ) / 100).toFixed(2) }}
            {{getPricePeriod}}
          </div>
        </v-sheet>
      </v-col>
      <v-col v-if="disableTeamUsers" cols=12 sm=6 class="d-flex justify-center align-center">
        <span class="text-center">
          {{$t('menus.resourceLimits.disableTeamMembersSentence1')}}

          <a href="#" @click.prevent="openSubscriptionContactDialog">
            {{$t('menus.resourceLimits.disableTeamMembersSentenceHere')}}
          </a>

          {{$t('menus.resourceLimits.disableTeamMembersSentence2')}}
        </span>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import { formatSize, toKilo, videoDuration } from '@/components/formatters.js';
import { useSystemStore } from '@/stores/SystemStore.js'
import { useMainStore } from '@/stores/MainStore.js'

export default {
  emits: ["input", "input"],
  name: "ResourceLimitItem",

  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    limitObject: {
      type: Object,
      required: false
    },
    addonObject: {
      type: Object,
      required: false,
    },
    filter: {
      type: String,
      required: false
    },
    disableTeamUsers: {
      type: Boolean,
      required: false,
    }
  },

  methods: {
    openSubscriptionContactDialog() {
      const mainStore = useMainStore();
      mainStore.showSubscriptionContactDialog();
    },
    increment: function() {
      // this[limitName] ++;
      this.$emit('input', this.value + 1);
    },
    decrement: function() {
      // if (this[limitName] > 0) {
      //   this[limitName]--;
      // }

      if (this.value > 0) {
        this.$emit('input', this.value - 1);
      }
    }
  },

  computed: {
    getSubscription: function() {
      const systemStore = useSystemStore();
      return systemStore.getSubscription;
    },
    isAddonValid: function() {
      return this.addonObject && this.addonObject.price && this.addonObject.price.id;
    },
    getFormattedValue: function() {
      return (value) => {
        switch (this.filter) {
          case "prettyBytes": return formatSize(value, 2);
          case "toKilo": return toKilo(value, 1);
          case "videoDuration": return videoDuration(value);
          default: return value;
        }
      }
    },
    getPricePeriod: function() {
      if (
        this.getSubscription &&
        this.getSubscription.interval &&
        this.getSubscription.interval == 'year' &&
        this.addonObject.price.type == "recurring"
      ) {
        return this.$t('menus.resourceLimits.perYear');
      }

      switch (this.addonObject.price.type) {
        case "recurring": return this.$t('menus.resourceLimits.perMonth');
        case "one_time": return this.$t('menus.resourceLimits.oneTime');
        default: return "";
      }
    },
  }
};
</script>

<style>

</style>
